"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maskBankNumber = maskBankNumber;
exports.maskPhoneNumber = maskPhoneNumber;

function maskBankNumber(bank) {
  if (!bank) return null;
  var length = bank.length; // This takes first 4 numbers of the bank string that will not be masked

  var firstPart = bank.substring(0, 4); // This takes first part of the bank string and does a look up
  // to match only the ones between the first and last four digits

  var secondPart = bank.substring(4, length - 4).replace(/\d/g, '*'); // This takes last 4 numbers of the bank string that will not be masked

  var thirdPart = bank.substring(length - 4);
  return firstPart + secondPart + thirdPart;
}

function maskPhoneNumber(phone) {
  if (!phone) return null;
  var numberLength = phone.length; // This takes first half of the phone string and will
  // match only the ones after the first two digits

  var firstHalf = phone.substring(3, numberLength / 2).replace(/\d/g, '*'); // This takes first half of the phone string and does a look up
  // to match only the ones preceding the last four digits

  var secondHalf = phone.substring(numberLength / 2).replace(/\d(?=\d{4})/g, '*');
  return phone.substring(0, 3) + firstHalf + secondHalf;
}